module.exports = __webpack_public_path__ + "img/Mockup3@2x.0ba553c1.png";